import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { sanitize } from '@ibe/services';

export enum MessageClass {
  DANGER = 'danger',
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success'
}

interface Props {
  message: string;
  messageClass: MessageClass;
  icon: IconProp;
  title?: string;
}

export const Message = (props: Props): JSX.Element => {
  const { message, messageClass, title, icon } = props;
  return (
    <>
      <div className={`alert alert-${messageClass}`} role="alert">
        <div className="font-weight-bold">
          {title && <FontAwesomeIcon icon={icon} className="mr-2" />}
          {title}
        </div>
        {!title && <FontAwesomeIcon icon={icon} className="mr-2" />}
        <span dangerouslySetInnerHTML={{ __html: sanitize(message, true) }} />
      </div>
    </>
  );
};
